export enum BlockValidationTypeEnum {
    noImageInTextBlock = 'noImageInTextBlock'
}
